import Vue from 'vue'
import Router from 'vue-router'
import { getUsuario, getIsUsuarioAutenticado, logout, setToken } from '@/store/auth'
import Home from '@/screens/Home.vue'
import CadastroCredenciados from '@/screens/credenciados/cadastroCredenciados.vue'
import ValidarCredenciados from '@/screens/credenciados/validarCredenciados.vue'
import ListagemSolicitacoes from '@/screens/solicitacoes/listagemSolicitacoes.vue'
import ListagemCredenciados from '@/screens/credenciados/listagemCredenciados.vue'
import ListagemProcessosCredenciar from '@/screens/credenciados/listagemProcessosCredenciar.vue'
import ListagemEditais from '@/screens/editais/listagemEditais.vue'
import Solicitacoes from '@/screens/perfil-credenciado/solicitacoes'
import CentralMensagens from '@/screens/perfil-credenciado/centralMensagens'
import ResponderMensagem from '@/screens/perfil-credenciado/responderMensagem'
import ListagemModelos from '@/screens/modelos/listagemModelos'
import Editais from '@/screens/Editais.vue'

import { PUBLIC_ROUTES, ROUTE_GROUPS } from '@/constants/constants'

Vue.use(Router)

const usuario = getUsuario();

const router = new Router({
  routes: [
    {
      path: '/editais',
      name: 'editais',
      component: Editais
    },
    {
      name: 'home',
      path: '',
      redirect: { name: !usuario ? 'credenciados/cadastro' : usuario?.perfilSelecionado?.codigo === 'CREDENCIADOS' ? 'credenciado/solicitacoes' : 'listagem-editais/listagem' },
    },
    {
      redirect: { name: 'editais/listagem' },
      path: '/listagem-editais',
      component: Home,
      children: [
        {
          path: '/listagem-editais/listagem',
          name: 'listagem-editais/listagem',
          component: ListagemEditais,
          meta: {
            routeGroup: ROUTE_GROUPS.LISTAGEM_EDITAIS,
            requiresAuth: ROUTE_GROUPS.CAGEO,
          }
        },
      ]
    },
    {
      path: '/solicitacoes',
      redirect: { name: 'solicitacoes/listagem' },
      component: Home,
      children: [
        {
          path: 'listagem/:idEdital',
          name: 'solicitacoes/listagem',
          component: ListagemSolicitacoes,
          meta: {
            routeGroup: ROUTE_GROUPS.SOLICITACOES_CAGEO,
            requiresAuth: ROUTE_GROUPS.CAGEO,
          }
        },
        {
          path: 'validar/:idSolicitacaoCredenciado',
          name: 'solicitacoes/validar',
          component: ValidarCredenciados,
          meta: {
            routeGroup: ROUTE_GROUPS.SOLICITACOES_CAGEO,
            requiresAuth: ROUTE_GROUPS.CAGEO,
          }
        },
        {
          path: 'visualizar/:idSolicitacaoCredenciado',
          name: 'solicitacoes/visualizar',
          component: ValidarCredenciados,
          meta: {
            routeGroup: ROUTE_GROUPS.SOLICITACOES_CAGEO,
            requiresAuth: ROUTE_GROUPS.CAGEO,
          }
        }
      ]
    },
    {
      path: '/credenciados',
      redirect: { name: 'credenciados/cadastro' },
      component: Home,
      children: [
        {
          path: 'listagem',
          name: 'credenciados/listagem',
          component: ListagemCredenciados,
          meta: {
            routeGroup: ROUTE_GROUPS.CREDENCIADOS,
            requiresAuth: ROUTE_GROUPS.CAGEO,
          }
        },
        {
          path: 'cadastro/:idEdital',
          name: 'credenciados/cadastro',
          component: CadastroCredenciados,
        },
        {
          path: '/credenciados/credenciar',
          name: 'credenciados/credenciar',
          component: ListagemProcessosCredenciar,
          meta: {
            routeGroup: ROUTE_GROUPS.CREDENCIAR_PROCESSOS,
            requiresAuth: ROUTE_GROUPS.CAGEO,
          }
        },
      ]
    },
    {
      path: '/credenciado',
      redirect: { name: 'credenciado/solicitacoes' },
      component: Home,
      children: [
        {
          path: 'solicitacoes',
          name: 'credenciado/solicitacoes',
          component: Solicitacoes,
          meta: {
            routeGroup: ROUTE_GROUPS.SOLICITACOES,
            requiresAuth: ROUTE_GROUPS.CREDENCIADOS,
          }
        },
        {
          path: 'editar/:idEdital',
          name: 'credenciado/editar',
          component: CadastroCredenciados,
          meta: {
            routeGroup: ROUTE_GROUPS.SOLICITACOES,
            requiresAuth: ROUTE_GROUPS.CREDENCIADOS,
          }
        },
        {
          name: 'Mensagens',
          path: '/credenciado/mensagens',
          component: CentralMensagens,
          meta: {
            routeGroup: ROUTE_GROUPS.MENSAGENS,
            requiresAuth: ROUTE_GROUPS.CREDENCIADOS,
          }
        }
      ]
    },
    {
      name: 'Responder',
      path: '/credenciado/mensagens/responder/:id',
      component: ResponderMensagem,
      meta: {
        routeGroup: ROUTE_GROUPS.MENSAGENS,
        requiresAuth: ROUTE_GROUPS.CREDENCIADOS,
      }
    },
    {
      name: 'Modelos',
      path: '/modelos/listar',
      component: ListagemModelos,
      meta: {
        routeGroup: ROUTE_GROUPS.CAGEO,
        requiresAuth: ROUTE_GROUPS.CAGEO,
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const token = new URL(location.href).searchParams.get('token')
  if (token) {
    setToken(token)
    location.href = '/'
  }
  if (PUBLIC_ROUTES.includes(to.name)) {
    next();
  } else if (usuario.perfilSelecionado.id === 73 && to.meta.requiresAuth !== ROUTE_GROUPS.CREDENCIADOS) {
    next(false)
  } else if (usuario.perfilSelecionado.id === 74 && to.meta.requiresAuth !== ROUTE_GROUPS.CAGEO) {
    next(false)
  } else {
    if (!getIsUsuarioAutenticado()) {
      logout()
    }
    next()
  }
})

export default router
